<div fxLayout="row wrap" class=container>
	<div *ngFor="let voice of voices; index as i" fxFlex=17.5 fxFlex.lt-lg=30 fxFlex.lt-md=47.5 style="margin-left: 2%; height: 25%;">
		<app-custom-card
		[id]="i"
		[text]="voices[i]"
		[icon]="icons[i]"
		(click)="this.goTo($event)">
		</app-custom-card>
	</div>
</div>

